(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 89886:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(17015);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 21437:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "m": function() { return /* reexport */ PostsTile; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@prismicio/richtext/dist/asText.js
var asText = __webpack_require__(98268);
// EXTERNAL MODULE: ./node_modules/next-translate-routes/link.js
var next_translate_routes_link = __webpack_require__(73966);
var link_default = /*#__PURE__*/__webpack_require__.n(next_translate_routes_link);
// EXTERNAL MODULE: ./src/@prismic/components/PrismicNextImage/index.ts + 3 modules
var PrismicNextImage = __webpack_require__(32243);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
;// CONCATENATED MODULE: ./src/@next/components/molecules/PostsTile/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  text-align: center;\n  transition: 0.3s;\n  min-height: 100%;\n  padding: 1rem;\n  &:hover {\n    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.15);\n    // background-color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n  position: relative;\n  img {\n    object-fit: cover;\n    width: 100%;\n    height: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 1rem 0;\n  text-align: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: 300;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  color: ",
        ";\n  text-transform: capitalize;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: Inter;\n  font-size: ",
        ";\n  line-height: ",
        ";\n  color: ",
        ";\n  margin-top: 7px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: Inter;\n  font-size: ",
        ";\n  line-height: ",
        ";\n  color: ",
        ";\n  text-transform: capitalize;\n  margin-top: 7px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

var Wrapper = globalStyles/* styled.div */.zo.div(_templateObject(), function(props) {
    return props.theme.colors.redLight;
}, function(props) {
    return props.theme.colors.white;
});
var Image = globalStyles/* styled.div */.zo.div(_templateObject1(), function(param) {
    var square = param.square;
    return square ? "100%" : undefined;
});
var Content = globalStyles/* styled.div */.zo.div(_templateObject2(), function(param) {
    var align = param.align;
    return align;
});
var Title = globalStyles/* styled.h3 */.zo.h3(_templateObject3(), function(props) {
    return props.theme.typography.extraFontFamily;
}, function(props) {
    return props.theme.typography.smallFontSize;
}, function(props) {
    return props.theme.typography.baseFontSize;
}, function(props) {
    return props.theme.colors.red;
});
var Text = globalStyles/* styled.p */.zo.p(_templateObject4(), function(props) {
    return props.theme.typography.labelFontSize;
}, function(props) {
    return props.theme.typography.smallFontSize;
}, function(props) {
    return props.theme.colors.baseFont;
});
var Tags = globalStyles/* styled.p */.zo.p(_templateObject5(), function(props) {
    return props.theme.typography.labelFontSize;
}, function(props) {
    return props.theme.typography.smallFontSize;
}, function(props) {
    return props.theme.colors.graySemi;
});

;// CONCATENATED MODULE: ./src/@next/components/molecules/PostsTile/PostsTile.tsx
/* eslint-disable @typescript-eslint/no-non-null-assertion */ 




var PostsTile = function(param) {
    var key = param.key, link = param.link, image = param.image, title = param.title, text = param.text, tags = param.tags, _align = param.align, align = _align === void 0 ? "center" : _align, _square = param.square, square = _square === void 0 ? true : _square;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: link,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                        square: square,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicNextImage/* PrismicNextImage */.Z, {
                            field: image,
                            height: 320,
                            sizes: "(max-width: 540px) 66vw, (max-width: 1279px) 50vw, 20vw"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                        align: align,
                        children: [
                            title && typeof title !== "string" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                children: asText/* asText */.S(title)
                            }),
                            title && typeof title === "string" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                children: title
                            }),
                            text && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                                children: asText/* asText */.S(text)
                            }),
                            tags && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tags, {
                                children: tags.join(", ")
                            })
                        ]
                    })
                ]
            })
        })
    }, key);
};

;// CONCATENATED MODULE: ./src/@next/components/molecules/PostsTile/index.ts



/***/ }),

/***/ 3177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ ProductReviewsWithQuery; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_regions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34465);
/* harmony import */ var _components_atoms_Loader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35582);
/* harmony import */ var _pages_NotFound__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85666);
/* harmony import */ var _sdk_gqlTypes_generatedHooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73134);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(10273);









function ProductReviewsWithQuery() {
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)().locale;
    var ref = (0,_sdk_gqlTypes_generatedHooks__WEBPACK_IMPORTED_MODULE_5__/* .useReviewsQuery */ ._s)({
        variables: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
            hasImages: true
        }, (0,_utils_regions__WEBPACK_IMPORTED_MODULE_2__/* .localeToSaleorQuery */ .KK)(locale)), {
            pageSize: 5
        })
    }), data = ref.data, loading = ref.loading, error = ref.error;
    if (error) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
            children: [
                "Error : ",
                error.message
            ]
        });
    }
    if (loading) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_atoms_Loader__WEBPACK_IMPORTED_MODULE_3__/* .Loader */ .a, {});
    }
    if (data && data.reviews === null) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_pages_NotFound__WEBPACK_IMPORTED_MODULE_4__/* .NotFound */ .T, {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(___WEBPACK_IMPORTED_MODULE_6__/* .ProductReviews */ .v, {
        reviews: data.reviews.edges.map(function(param) {
            var node = param.node;
            return node;
        })
    });
}


/***/ }),

/***/ 85666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* reexport */ NotFound; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./node_modules/next-translate-routes/link.js
var next_translate_routes_link = __webpack_require__(73966);
var link_default = /*#__PURE__*/__webpack_require__.n(next_translate_routes_link);
// EXTERNAL MODULE: ./src/paths.ts
var paths = __webpack_require__(4032);
// EXTERNAL MODULE: ./src/@next/components/atoms/Button/index.ts + 2 modules
var Button = __webpack_require__(45506);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
// EXTERNAL MODULE: ./src/@next/globalStyles/constants.ts
var constants = __webpack_require__(38408);
;// CONCATENATED MODULE: ./src/@next/pages/NotFound/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  text-align: center;\n  padding: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  font-weight: 900;\n  line-height: 100%;\n  color: ",
        ";\n  padding-bottom: 20px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  min-width: ",
        ";\n  height: 2px;\n  margin-top: ",
        ";\n  margin-bottom: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    p {\n      display: inline;\n    }\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: ",
        ";\n  min-width: 88%;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var Page = globalStyles/* styled.div */.zo.div(_templateObject(), "".concat(2 * constants/* spacer */.OF, "rem ").concat(constants/* spacer */.OF, "rem"));
var Header = globalStyles/* styled.h2 */.zo.h2(_templateObject1(), function(param) {
    var typography = param.theme.typography;
    return typography.ultraBigFont;
}, function(props) {
    return props.theme.colors.primary;
});
var Ruler = globalStyles/* styled.div */.zo.div(_templateObject2(), function(props) {
    return props.theme.colors.primary;
}, "".concat(10 * constants/* spacer */.OF, "rem"), "".concat(constants/* spacer */.OF, "rem"), "".concat(3 * constants/* spacer */.OF, "rem"));
var Message = globalStyles/* styled.div */.zo.div(_templateObject4(), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject3()));
var Action = globalStyles/* styled.div */.zo.div(_templateObject5(), "".concat(2 * constants/* spacer */.OF, "rem 0"));

;// CONCATENATED MODULE: ./src/@next/pages/NotFound/NotFound.tsx







var NotFound = function() {
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                children: "404"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Ruler, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Message, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: intl.formatMessage({
                            defaultMessage: "We can’t seem to find a page you are looking for!",
                            id: "A8OWpi"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: intl.formatMessage({
                            defaultMessage: "You may have mistyped the address or the page may have moved.",
                            id: "+qoOl7"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: intl.formatMessage({
                            defaultMessage: "We’re sorry for the error and hope you’ll have a good day.",
                            id: "5wk80E"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Action, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: paths/* paths.home */.H.home,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            color: "secondary",
                            size: "lg",
                            children: intl.formatMessage({
                                defaultMessage: "Back to home",
                                id: "aIRWQB"
                            })
                        })
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/@next/pages/NotFound/index.tsx



/***/ }),

/***/ 17015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/core/SEO/Homepage/structuredData.tsx
var structuredData = function(shop) {
    return JSON.stringify({
        "@context": "https://schema.org",
        "@type": "WebSite",
        description: shop ? shop.description : "",
        name: shop ? shop.name : "",
        url: "https://www.renodoors.eu/" || 0
    });
};

// EXTERNAL MODULE: ./src/@next/components/atoms/ErrorMessage/index.ts + 2 modules
var ErrorMessage = __webpack_require__(98615);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@prismicio/react/dist/PrismicRichText.js + 16 modules
var PrismicRichText = __webpack_require__(50385);
// EXTERNAL MODULE: ./src/@next/hooks/useMediaQuery/index.ts + 3 modules
var useMediaQuery = __webpack_require__(15996);
// EXTERNAL MODULE: ./src/@next/globalStyles/constants.ts
var constants = __webpack_require__(38408);
// EXTERNAL MODULE: ./src/@prismic/components/PrismicNextImage/index.ts + 3 modules
var PrismicNextImage = __webpack_require__(32243);
// EXTERNAL MODULE: ./src/@next/components/atoms/Button/index.ts + 2 modules
var Button = __webpack_require__(45506);
// EXTERNAL MODULE: ./src/@prismic/prismic-config.ts + 31 modules
var prismic_config = __webpack_require__(93092);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./src/@next/globalStyles/index.ts + 3 modules
var globalStyles = __webpack_require__(23042);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(52015);
// EXTERNAL MODULE: ./src/images/title-top.svg
var title_top = __webpack_require__(43157);
;// CONCATENATED MODULE: ./src/images/title-bottom.svg
var title_bottom_namespaceObject = __webpack_require__.p + "static/images/title-bottom.svg";
;// CONCATENATED MODULE: ./src/@next/components/organisms/HomePageHero/styles.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    top: 0;\n    left: -40px;\n  }\n  35% {\n    top: 175px;\n    left: -40px;\n  }\n  100% {\n    top: 175px;\n    left: 430px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    top: -5px;\n    left: -19px;\n  }\n  35% {\n    top: 140px;\n    left: -19px;\n  }\n  100% {\n    top: 140px;\n    left: 310px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    top: -5px;\n    left: -19px;\n  }\n  35% {\n    top: 150px;\n    left: -19px;\n  }\n  100% {\n    top: 150px;\n    left: 250px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    top: -10px;\n    left: -12px;\n  }\n  35% {\n    top: 50px;\n    left: -12px;\n  }\n  100% {\n    top: 50px;\n    left: 300px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    height: 0;\n  }\n  to {\n    height: 140px;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    height: 0;\n  }\n  to {\n    height: 120px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    height: 0;\n  }\n  to {\n    height: 100px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  from {\n    height: 0;\n  }\n  to {\n    height: 40px;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 350px;\n  "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    text-align: center;\n    max-width: 400px;\n    padding: 0;\n    height: 100%;\n    justify-content: space-between;\n    min-height: 270px;\n    margin: 0 auto;\n    height: 100%;\n    display: flex;\n    align-items: center;\n  "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-sizing: content-box;\n  max-width: 490px;\n  display: flex;\n  flex-direction: column;\n  z-index: 1;\n  margin-left: 5%;\n  position: absolute;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    justify-content: center;\n  "
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  background-color: ",
        ";\n  display: flex !important;\n  align-items: center;\n  ",
        "\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 100%;\n    margin-top: 90px;\n    &:before {\n      background: linear-gradient(\n        180deg,\n        #f5f1f0 80%,\n        rgba(255, 255, 255, 0) 100%\n      );\n      height:25%;\n      width:100%;\n    }\n  "
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      max-width: 100%;\n      height: 100%;\n    "
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow: hidden;\n  width: 100%;\n  height: 50vw;\n  &:before {\n    content: '';\n    z-index: 1;\n    position: absolute;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    background: linear-gradient(\n      90deg,\n      #f5f1f0 80%,\n      rgba(255, 255, 255, 0) 100%\n    );\n    opacity: 0.9;\n    height: 100%;\n    width: 40%;\n  }\n  ",
        "\n  img {\n    max-height: 100%;\n    width: 100%;\n    object-fit: cover;\n    ",
        "\n  }\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 44px;\n    // height: 144px;\n  "
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 30px;\n    // height: 137px;\n  "
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-top: 1em;\n    margin-bottom: 10px;\n    // height: 75px;\n  "
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  // height: 190px;\n  margin-bottom: 60px;\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 30px 0 22px;\n    // height: 144px;\n  "
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 30px 0 15px;\n    // height: 137px;\n  "
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 15px 0 10px;\n    // height: 85px;\n    width: 320px;\n    margin: 0 auto;\n  "
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  padding: 40px 0 22px;\n  // height: 190px;\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      font-size: ",
        ";\n      line-height: ",
        ";\n    "
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 365px;\n    animation-name: ",
        ";\n  "
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 280px;\n    animation-name: ",
        ";\n  "
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 320px;\n    animation-name: ",
        ";\n  "
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 500px;\n  height: 0;\n  overflow: hidden;\n  animation-fill-mode: both;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: ",
        ";\n  h1,\n  h2,\n  h3 {\n    font-size: inherit;\n    line-height: inherit;\n    ",
        "\n  }\n  & em {\n    color: ",
        ";\n  }\n  animation-name: ",
        ";\n  animation-duration: 0.3s;\n  animation-delay: 1.1s;\n  opacity: 1;\n  transition: opacity;\n  transition-delay: 0.7s;\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    left: -25px;\n    width: 64px;\n    height: 15px;\n  "
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    left: -15px;\n    width: 35px;\n    height: 15px;\n  "
    ]);
    _templateObject30 = function _templateObject30() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  left: -44px;\n  top: 0;\n  display: inline-block;\n  width: 92px;\n  height: 15px;\n  background: url(",
        ") no-repeat left top;\n  background-size: contain;\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject31 = function _templateObject31() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 64px;\n    height: 15px;\n    left: -19px;\n    top: -5px;\n    animation-name: ",
        ";\n  "
    ]);
    _templateObject32 = function _templateObject32() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    animation-name: ",
        ";\n  "
    ]);
    _templateObject33 = function _templateObject33() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 35px;\n    height: 15px;\n    left: -12px;\n    top: -10px;\n    animation-name: ",
        ";\n  "
    ]);
    _templateObject34 = function _templateObject34() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  display: inline-block;\n  width: 92px;\n  height: 15px;\n  background: url(",
        ") no-repeat right bottom;\n  background-size: contain;\n  animation-fill-mode: both;\n  top: 0;\n  left: -40px;\n  ",
        "\n  ",
        "\n  ",
        "\n\n  animation-name: ",
        ";\n  animation-duration: 1s;\n  animation-delay: 1s;\n  opacity: 1;\n  transition: opacity;\n  transition-delay: 1s;\n"
    ]);
    _templateObject35 = function _templateObject35() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 40px;\n  "
    ]);
    _templateObject36 = function _templateObject36() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 30px;\n  "
    ]);
    _templateObject37 = function _templateObject37() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 10px;\n  "
    ]);
    _templateObject38 = function _templateObject38() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 460px;\n  line-height: 1.6em;\n  margin-bottom: 60px;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  * {\n    font: inherit;\n    color: inherit;\n    line-height: inherit;\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject39 = function _templateObject39() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: 245px;\n    "
    ]);
    _templateObject40 = function _templateObject40() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: 220px;\n    "
    ]);
    _templateObject41 = function _templateObject41() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin-bottom: 2em;\n    "
    ]);
    _templateObject42 = function _templateObject42() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  button {\n    width: 320px;\n    padding-left: 0;\n    padding-right: 0;\n    ",
        "\n    ",
        "\n    ",
        "\n  }\n"
    ]);
    _templateObject43 = function _templateObject43() {
        return data;
    };
    return data;
}




var ArrowOpen = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject());
var ArrowOpenLarge = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject1());
var ArrowOpenMedium = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject2());
var ArrowOpenSmall = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject3());
var ContentOpen = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject4());
var ContentOpenLarge = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject5());
var ContentOpenMedium = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject6());
var ContentOpenSmall = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject7());
var Content = globalStyles/* styled.div */.zo.div(_templateObject10(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject8()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject9()));
var Wrapper = globalStyles/* styled.div */.zo.div(_templateObject12(), function(props) {
    return props.theme.colors.redLight;
}, globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject11()));
var Image = globalStyles/* styled.div */.zo.div(_templateObject15(), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject13()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject14()));
var Title = globalStyles/* styled.div */.zo.div(_templateObject19(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject16()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject17()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject18()));
var TitleInner = globalStyles/* styled.div */.zo.div(_templateObject23(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject20()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject21()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject22()));
var TitleContent = globalStyles/* styled.div */.zo.div(_templateObject28(), function(props) {
    return props.theme.typography.thinFontFamily;
}, function(props) {
    return props.theme.typography.h2FontSize;
}, function(props) {
    return props.theme.typography.h2FontSize;
}, globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject24(), function(props) {
    return props.theme.typography.h4FontSize;
}, function(props) {
    return props.theme.typography.h4FontSize;
}), function(props) {
    return props.theme.colors.red;
}, ContentOpen, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject25(), ContentOpenLarge), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject26(), ContentOpenMedium), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject27(), ContentOpenSmall));
var TitleBefore = globalStyles/* styled.div */.zo.div(_templateObject31(), title_top, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject29()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject30()));
var TitleAfter = globalStyles/* styled.div */.zo.div(_templateObject35(), title_bottom_namespaceObject, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject32(), ArrowOpenLarge), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject33(), ArrowOpenMedium), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject34(), ArrowOpenSmall), ArrowOpen);
var Text = globalStyles/* styled.div */.zo.div(_templateObject39(), function(props) {
    return props.theme.typography.extraFontFamily;
}, function(props) {
    return props.theme.typography.baseFontSize;
}, globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject36()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject37()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject38()));
var styles_Button = globalStyles/* styled.a */.zo.a(_templateObject43(), globalStyles/* media.largeScreen */.BC.largeScreen(_templateObject40()), globalStyles/* media.mediumScreen */.BC.mediumScreen(_templateObject41()), globalStyles/* media.smallScreen */.BC.smallScreen(_templateObject42()));

;// CONCATENATED MODULE: ./src/@next/components/organisms/HomePageHero/HomePageHero.tsx









function HomePageHero(param) {
    var hero = param.hero;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useMediaQuery/* useMediaQuery */.a)("(max-width: ".concat(constants/* smallScreen */.xC, "px)")), 1), isSmallScreen = ref[0];
    var ref1 = hero[0], image = ref1.image, banner_title = ref1.banner_title, text = ref1.text, button_label = ref1.button_label, button_link = ref1.button_link;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
        className: "home-page-hero",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                className: "home-page-hero__image-wr",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicNextImage/* PrismicNextImage */.Z, {
                    field: image,
                    width: 1920,
                    height: 960,
                    priority: true
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                className: "home-page-hero__content",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        className: "home-page-hero__title-wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleInner, {
                            className: "home-page-hero__title-inner",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleBefore, {
                                    className: "home-page-hero__title-before"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleContent, {
                                    className: "home-page-hero__title-content",
                                    children: banner_title && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                                        field: banner_title
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TitleAfter, {
                                    className: "home-page-hero__title-after"
                                })
                            ]
                        })
                    }),
                    !isSmallScreen && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text, {
                        className: "home-page-hero__text",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                            field: text
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Button, {
                        className: "home-page-hero__button",
                        href: (0,prismic_config/* linkResolver */.kG)(button_link),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            size: "lg",
                            color: "primary",
                            children: button_label
                        })
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/@next/components/organisms/HomePageHero/index.ts


// EXTERNAL MODULE: ./node_modules/@prismicio/react/dist/SliceZone.js + 1 modules
var SliceZone = __webpack_require__(172);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./src/@next/globalStyles/utils.ts + 1 modules
var utils = __webpack_require__(44610);
// EXTERNAL MODULE: ./src/@next/components/templates/Container/index.ts
var Container = __webpack_require__(95213);
;// CONCATENATED MODULE: ./src/@next/components/slices/SliceBenefits/styles.ts

function styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 2rem 2rem;\n"
    ]);
    styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-direction: column;\n    gap: 1rem;\n    align-items: flex-start;\n  "
    ]);
    styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  ",
        "\n"
    ]);
    styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n"
    ]);
    styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 126px;\n    height: 126px;\n    margin-bottom: 20px;\n  "
    ]);
    styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 148px;\n  height: 148px;\n  margin: 0 auto;\n  margin-bottom: 40px;\n  position: relative;\n  ",
        "\n  img {\n    position: absolute;\n    left: 0;\n    top: 0;\n  }\n  svg {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n  }\n"
    ]);
    styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  img {\n    opacity: 0.3;\n    transition: opacity 0.3s;\n  }\n  * {\n    transition: fill 0.4s;\n  }\n"
    ]);
    styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  img {\n    transform: scale(0) !important;\n    opacity: 0;\n    transition: opacity 0.3s, transform 0.4s;\n    transform-origin: center;\n  }\n  svg {\n    transform: scale(0) !important;\n    opacity: 0;\n    transition: opacity 0.3s, transform 0.4s;\n    transform-origin: center;\n  }\n"
    ]);
    styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 35px 30px;\n  "
    ]);
    styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex: 0 0 50%;\n  "
    ]);
    styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex: 0 0 100%;\n    padding: 25px;\n    &:before {\n      content: none !important;\n    }\n  "
    ]);
    styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n            transform: none;\n          "
    ]);
    styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 0 0 25%;\n  padding: 45px 35px;\n  position: relative;\n  z-index: 1;\n  ",
        "\n  ",
        "\n  ",
        "\n  &:before {\n    content: '';\n    display: block;\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    height: 0;\n    transition: height 0.4s;\n    background-color: ",
        ";\n    z-index: -1;\n  }\n  &:hover,\n  &:active,\n  &:focus {\n    &:before {\n      height: 100%;\n    }\n    .benefits {\n      &__icon {\n        &-hover {\n          img {\n            transform: scale(1) !important;\n            opacity: 1;\n          }\n          svg {\n            transform: scale(1) !important;\n            opacity: 1;\n          }\n        }\n        &-shade {\n          img {\n            opacity: 0.6;\n          }\n          * {\n            fill: rgba($red, 0.6);\n          }\n        }\n      }\n      &__item {\n        &-hint {\n          opacity: 0;\n        }\n        &-title {\n          transform: translateY(-10px);\n          ",
        "\n        }\n        &-description {\n          opacity: 0.8;\n          transform: translateY(-10px);\n        }\n        &-more {\n          opacity: 0;\n          transform: translateY(10px);\n        }\n      }\n    }\n  }\n"
    ]);
    styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function styles_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 12px;\n  "
    ]);
    styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function styles_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  "
    ]);
    styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function styles_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  line-height: 1.2em;\n  margin-bottom: 16px;\n  transition: 0.3s;\n  font-family: ",
        ";\n  font-size: ",
        ";\n\n  ",
        "\n  ",
        "\n  * {\n    font: inherit;\n    line-height: inherit;\n  }\n"
    ]);
    styles_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function styles_templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: none;\n    margin-bottom: 0;\n    margin-right: 10px;\n    &.mobile-only {\n      display: block;\n    }\n  "
    ]);
    styles_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function styles_templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.3em;\n  letter-spacing: 2px;\n  text-transform: uppercase;\n  margin-bottom: 20px;\n  &.mobile-only {\n    display: none;\n  }\n  ",
        "\n"
    ]);
    styles_templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function styles_templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: none;\n  "
    ]);
    styles_templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function styles_templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  ",
        "\n"
    ]);
    styles_templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function styles_templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: none;\n  "
    ]);
    styles_templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function styles_templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n  font-family: ",
        ";\n  line-height: 1.3em;\n  letter-spacing: 2px;\n  text-transform: uppercase;\n  position: absolute;\n  left: 30px;\n  bottom: 35px;\n  transition: 0.3s;\n  ",
        "\n"
    ]);
    styles_templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function styles_templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: none;\n  "
    ]);
    styles_templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function styles_templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  line-height: 1.6em;\n  font-size: ",
        ";\n  font-family: ",
        ";\n  position: absolute;\n  opacity: 0.8;\n  top: 0;\n  left: 0;\n  transition: 0.2s;\n  ",
        "\n  * {\n    font: inherit;\n    font-size: inherit;\n    line-height: inherit;\n  }\n"
    ]);
    styles_templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function styles_templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: none;\n  "
    ]);
    styles_templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function styles_templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  line-height: 1.6em;\n  font-size: ",
        ";\n  font-family: ",
        ";\n  opacity: 0;\n  transition: 0.4s;\n  ",
        "\n  * {\n    font: inherit;\n    font-size: inherit;\n    line-height: inherit;\n  }\n"
    ]);
    styles_templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function styles_templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    styles_templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}



var styles_Wrapper = globalStyles/* styled.div */.zo.div(styles_templateObject());
var styles_Container = (0,globalStyles/* styled */.zo)(Container/* Container */.W2)(styles_templateObject1());
var Header = globalStyles/* styled.div */.zo.div(styles_templateObject3(), globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject2()));
var styles_Title = globalStyles/* styled.h2 */.zo.h2(styles_templateObject4(), utils/* pageTitle */.tj);
var List = globalStyles/* styled.ul */.zo.ul(styles_templateObject5());
var IconWrapper = globalStyles/* styled.div */.zo.div(styles_templateObject7(), globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject6()));
var IconShade = globalStyles/* styled.div */.zo.div(styles_templateObject8());
var IconHover = globalStyles/* styled.div */.zo.div(styles_templateObject9());
var Item = globalStyles/* styled.li */.zo.li(styles_templateObject14(), globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject10()), globalStyles/* media.mediumScreen */.BC.mediumScreen(styles_templateObject11()), globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject12()), function(props) {
    return props.theme.colors.light;
}, globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject13()));
var ItemTitle = globalStyles/* styled.div */.zo.div(styles_templateObject17(), function(props) {
    return props.theme.typography.thinFontFamily;
}, function(props) {
    return props.theme.typography.h5FontSize;
}, globalStyles/* media.largeScreen */.BC.largeScreen(styles_templateObject15()), globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject16()));
var ItemCount = globalStyles/* styled.div */.zo.div(styles_templateObject19(), function(props) {
    return props.theme.colors.gold;
}, function(props) {
    return props.theme.typography.baseFontSize;
}, globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject18()));
var ItemContent = globalStyles/* styled.div */.zo.div(styles_templateObject21(), globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject20()));
var ItemMore = globalStyles/* styled.div */.zo.div(styles_templateObject23(), function(props) {
    return props.theme.colors.red;
}, function(props) {
    return props.theme.typography.smallFontSize;
}, function(props) {
    return props.theme.typography.boldFontFamily;
}, globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject22()));
var ItemHint = globalStyles/* styled.div */.zo.div(styles_templateObject25(), function(props) {
    return props.theme.typography.smallFontSize;
}, function(props) {
    return props.theme.typography.extraFontFamily;
}, globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject24()));
var ItemDescription = globalStyles/* styled.div */.zo.div(styles_templateObject27(), function(props) {
    return props.theme.typography.smallFontSize;
}, function(props) {
    return props.theme.typography.extraFontFamily;
}, globalStyles/* media.smallScreen */.BC.smallScreen(styles_templateObject26()));
var SliceBenefits_styles_Button = globalStyles/* styled.div */.zo.div(styles_templateObject28());

// EXTERNAL MODULE: ./src/intl.ts
var src_intl = __webpack_require__(72110);
;// CONCATENATED MODULE: ./src/@next/components/slices/SliceBenefits/SliceBenefits.tsx






function SliceBenefits(param) {
    var fields = param.slice.fields;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Wrapper, {
        className: "benefits",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                    className: "benefits__header",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Title, {
                        className: "benefits__title",
                        children: intl.formatMessage(src_intl/* commonMessages.SeeAndFeelTheDifference */.i4.SeeAndFeelTheDifference)
                    })
                }),
                fields && /*#__PURE__*/ (0,jsx_runtime.jsx)(List, {
                    className: "benefits__list",
                    children: fields.map(function(item, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                            className: "benefits__item",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemCount, {
                                    className: "benefits__item-count",
                                    children: [
                                        "0",
                                        i + 1
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(IconWrapper, {
                                    className: "benefits__icon-wr",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconShade, {
                                            className: "benefits__icon-shade",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicNextImage/* PrismicNextImage */.Z, {
                                                    field: item.img_shade
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "benefits__icon",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicNextImage/* PrismicNextImage */.Z, {
                                                    field: item.img_default
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconHover, {
                                            className: "benefits__icon-hover",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicNextImage/* PrismicNextImage */.Z, {
                                                    field: item.img_hover
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemTitle, {
                                    className: "benefits__item-title",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemCount, {
                                            className: "benefits__item-count mobile-only",
                                            children: [
                                                "0",
                                                i + 1
                                            ]
                                        }),
                                        item.title && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                                            field: item.title
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ItemContent, {
                                    className: "benefits__item-content",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemHint, {
                                            className: "benefits__item-text benefits__item-hint",
                                            children: item.text && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                                                field: item.text
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemDescription, {
                                            className: "benefits__item-text benefits__item-description",
                                            children: item.more_text && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                                                field: item.more_text
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemMore, {
                                    className: "benefits__item-more",
                                    children: intl.formatMessage(src_intl/* commonMessages.more */.i4.more)
                                })
                            ]
                        }, i);
                    })
                })
            ]
        })
    });
}
SliceBenefits.componentName = "benefits";

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceBenefits/index.ts


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/next-translate-routes/link.js
var next_translate_routes_link = __webpack_require__(73966);
var link_default = /*#__PURE__*/__webpack_require__.n(next_translate_routes_link);
// EXTERNAL MODULE: ./src/@next/components/molecules/PostsTile/index.ts + 2 modules
var PostsTile = __webpack_require__(21437);
// EXTERNAL MODULE: ./src/images/chevron_left.svg
var chevron_left = __webpack_require__(36811);
// EXTERNAL MODULE: ./src/images/chevron_right.svg
var chevron_right = __webpack_require__(81111);
;// CONCATENATED MODULE: ./src/@next/components/slices/SliceCollections/styles.ts

function SliceCollections_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      display: block !important;\n      width: 40px;\n      height: 40px;\n    "
    ]);
    SliceCollections_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SliceCollections_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .slick-arrow {\n    position: absolute;\n    top: 50%;\n    -webkit-transform: translateY(-50%);\n    transform: translateY(-50%);\n    border-radius: 50%;\n    width: 50px;\n    height: 50px;\n    color: transparent;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: contain;\n    box-shadow: 0px 4px 34px rgba(0, 0, 0, 0.08);\n    z-index: 1;\n    transform: translate3d(0, 0, 0);\n\n    ",
        "\n  }\n"
    ]);
    SliceCollections_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SliceCollections_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .slick-prev {\n    background: url(",
        ") no-repeat center !important;\n  }\n"
    ]);
    SliceCollections_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SliceCollections_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .slick-next {\n    background: url(",
        ") no-repeat center !important;\n  }\n"
    ]);
    SliceCollections_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SliceCollections_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      overflow: visible;\n    "
    ]);
    SliceCollections_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SliceCollections_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .slick-track {\n    display: flex !important;\n    ",
        "\n  }\n"
    ]);
    SliceCollections_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function SliceCollections_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .slick-slide {\n    height: auto;\n\n    & > div {\n      height: 100%;\n\n      & > div {\n        height: 100%;\n      }\n    }\n  }\n"
    ]);
    SliceCollections_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function SliceCollections_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin: 0px -12px;\n    "
    ]);
    SliceCollections_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function SliceCollections_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    "
    ]);
    SliceCollections_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function SliceCollections_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      margin: 0px -4px;\n      overflow: visible;\n    "
    ]);
    SliceCollections_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function SliceCollections_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .slick-list {\n    margin: 0px -20px;\n\n    ",
        "\n\n    ",
        "\n\n    ",
        "\n  }\n"
    ]);
    SliceCollections_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function SliceCollections_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  .slick-disabled {\n    opacity: 0;\n  }\n"
    ]);
    SliceCollections_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function SliceCollections_styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: ",
        ";\n"
    ]);
    SliceCollections_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function SliceCollections_styles_templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    overflow: hidden;\n  "
    ]);
    SliceCollections_styles_templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function SliceCollections_styles_templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 2rem 2rem;\n\n  ",
        "\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    SliceCollections_styles_templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function SliceCollections_styles_templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex-direction: column;\n    gap: 1rem;\n    align-items: flex-start;\n  "
    ]);
    SliceCollections_styles_templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function SliceCollections_styles_templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  ",
        "\n"
    ]);
    SliceCollections_styles_templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function SliceCollections_styles_templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    SliceCollections_styles_templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function SliceCollections_styles_templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    letter-spacing: -0.5px;\n  "
    ]);
    SliceCollections_styles_templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function SliceCollections_styles_templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  font-style: normal;\n  font-weight: normal;\n  line-height: 100%;\n  color: ",
        ";\n  ",
        "\n\n  &:after {\n    content: '';\n    display: block;\n    height: 2px;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: ",
        ";\n  }\n"
    ]);
    SliceCollections_styles_templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function SliceCollections_styles_templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block !important;\n  height: 100%;\n  padding: 1em;\n"
    ]);
    SliceCollections_styles_templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}






var slickArrow = (0,styled_components_browser_esm/* css */.iv)(SliceCollections_styles_templateObject1(), globalStyles/* media.smallScreen */.BC.smallScreen(SliceCollections_styles_templateObject()));
var slickPrev = (0,styled_components_browser_esm/* css */.iv)(SliceCollections_styles_templateObject2(), chevron_left);
var slickNext = (0,styled_components_browser_esm/* css */.iv)(SliceCollections_styles_templateObject3(), chevron_right);
var slickTrack = (0,styled_components_browser_esm/* css */.iv)(SliceCollections_styles_templateObject5(), globalStyles/* media.smallScreen */.BC.smallScreen(SliceCollections_styles_templateObject4()));
var slickSlide = (0,styled_components_browser_esm/* css */.iv)(SliceCollections_styles_templateObject6());
var slickList = (0,styled_components_browser_esm/* css */.iv)(SliceCollections_styles_templateObject10(), globalStyles/* media.largeScreen */.BC.largeScreen(SliceCollections_styles_templateObject7()), globalStyles/* media.mediumScreen */.BC.mediumScreen(SliceCollections_styles_templateObject8()), globalStyles/* media.smallScreen */.BC.smallScreen(SliceCollections_styles_templateObject9()));
var slickDisabled = (0,styled_components_browser_esm/* css */.iv)(SliceCollections_styles_templateObject11());
var SliceCollections_styles_Wrapper = globalStyles/* styled.div */.zo.div(SliceCollections_styles_templateObject12(), function(props) {
    return props.theme.colors.light;
});
var SliceCollections_styles_Container = (0,globalStyles/* styled */.zo)(Container/* Container */.W2)(SliceCollections_styles_templateObject14(), globalStyles/* media.smallScreen */.BC.smallScreen(SliceCollections_styles_templateObject13()), slickList, slickTrack, slickSlide, slickArrow, slickPrev, slickNext, slickDisabled);
var styles_Header = globalStyles/* styled.div */.zo.div(SliceCollections_styles_templateObject16(), globalStyles/* media.smallScreen */.BC.smallScreen(SliceCollections_styles_templateObject15()));
var SliceCollections_styles_Title = globalStyles/* styled.h2 */.zo.h2(SliceCollections_styles_templateObject17(), utils/* pageTitle */.tj);
var Link = globalStyles/* styled.a */.zo.a(SliceCollections_styles_templateObject19(), function(props) {
    return props.theme.typography.thinFontFamily;
}, function(props) {
    return props.theme.typography.baseFontSize;
}, function(props) {
    return props.theme.colors.baseFont;
}, globalStyles/* media.largeScreen */.BC.largeScreen(SliceCollections_styles_templateObject18()), function(props) {
    return props.theme.colors.red;
});
var Slide = globalStyles/* styled.div */.zo.div(SliceCollections_styles_templateObject20());

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceCollections/SliceCollections.tsx













var sliderSettings = {
    arrows: true,
    autoplay: false,
    dots: false,
    infinite: false,
    // centerMode: true,
    slidesToShow: 3,
    responsive: [
        {
            breakpoint: constants/* mediumScreen */.M7,
            settings: {
                slidesToShow: 2,
                swipeToSlide: true
            }
        },
        {
            breakpoint: constants/* smallScreen */.xC,
            settings: {
                slidesToShow: 1,
                swipeToSlide: true
            }
        }, 
    ]
};
function SliceCollections(param) {
    var _slice = param.slice, fields = _slice.fields, primary = _slice.primary;
    var slider = (0,react.useRef)(null);
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SliceCollections_styles_Wrapper, {
        className: "slice-collections",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SliceCollections_styles_Container, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Header, {
                    children: [
                        (primary === null || primary === void 0 ? void 0 : primary.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)(SliceCollections_styles_Title, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                                field: primary.title
                            })
                        }),
                        (primary === null || primary === void 0 ? void 0 : primary.link) && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: (0,prismic_config/* linkResolver */.kG)(primary.link),
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link, {
                                children: intl.formatMessage(src_intl/* commonMessages.showMore */.i4.showMore)
                            })
                        })
                    ]
                }),
                fields && /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sliderSettings), {
                    ref: slider,
                    children: fields.map(function(item, i) {
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        if (!item) {
                            return null;
                        }
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Slide, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PostsTile/* PostsTile */.m, {
                                link: (0,prismic_config/* linkResolver */.kG)(item === null || item === void 0 ? void 0 : item.link),
                                image: item === null || item === void 0 ? void 0 : item.image,
                                title: item === null || item === void 0 ? void 0 : item.title,
                                text: item === null || item === void 0 ? void 0 : item.text,
                                align: "left",
                                square: true
                            }, i)
                        });
                    })
                }))
            ]
        })
    });
}
SliceCollections.componentName = "collections";

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceCollections/index.ts


;// CONCATENATED MODULE: ./src/@next/components/slices/SliceCta/styles.ts

function SliceCta_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    min-height: initial;\n  "
    ]);
    SliceCta_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SliceCta_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  margin: 0 auto;\n  ",
        "\n"
    ]);
    SliceCta_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SliceCta_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  height: 100%;\n  z-index: -1;\n  pointer-events: none;\n  overflow: hidden;\n  iframe {\n    width: 100vw;\n    height: 56.25vw; /* Given a 16:9 aspect ratio, 9/16*100 = 56.25 */\n    min-height: 100vh;\n    min-width: 177.77vh; /* Given a 16:9 aspect ratio, 16/9*100 = 177.77 */\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n  }\n  img {\n    height: 100%;\n  }\n"
    ]);
    SliceCta_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SliceCta_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 110px 0;\n  "
    ]);
    SliceCta_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SliceCta_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 50px 0;\n  "
    ]);
    SliceCta_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SliceCta_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  position: absolute;\n  top: 0;\n  z-index: 1;\n  display: flex;\n  justify-content: ",
        ";\n  height: 100%;\n  width: 100%;\n  ",
        "\n  ",
        "\n  &:before {\n    content: '';\n    z-index: -1;\n    position: absolute;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    background: linear-gradient(\n      180deg,\n      #e9dada 0%,\n      rgba(255, 255, 255, 0) 100%\n    );\n    opacity: 0.7;\n  }\n"
    ]);
    SliceCta_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function SliceCta_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 550px;\n  "
    ]);
    SliceCta_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function SliceCta_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 790px;\n  // margin: 0 auto;\n  ",
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n"
    ]);
    SliceCta_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function SliceCta_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding: 0 25px;\n  "
    ]);
    SliceCta_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function SliceCta_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  line-height: 1em;\n  margin-bottom: 20px;\n  ",
        "\n  * {\n    font: inherit;\n  }\n"
    ]);
    SliceCta_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function SliceCta_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: 455px;\n    margin: 0 auto 40px;\n  "
    ]);
    SliceCta_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function SliceCta_styles_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 30px;\n    padding: 0 25px;\n  "
    ]);
    SliceCta_styles_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function SliceCta_styles_templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-family: ",
        ";\n  font-size: ",
        ";\n  max-width: 593px;\n  margin: 0 auto 60px;\n  line-height: 1.6em;\n  opacity: 0.8;\n  ",
        "\n  ",
        "\n  * {\n    font: inherit;\n  }\n"
    ]);
    SliceCta_styles_templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}

var SliceCta_styles_Wrapper = globalStyles/* styled.div */.zo.div(SliceCta_styles_templateObject1(), globalStyles/* media.smallScreen */.BC.smallScreen(SliceCta_styles_templateObject()));
var Video = globalStyles/* styled.div */.zo.div(SliceCta_styles_templateObject2());
var styles_Content = globalStyles/* styled.div */.zo.div(SliceCta_styles_templateObject5(), function(param) {
    var justify = param.justify;
    return justify;
}, globalStyles/* media.mediumScreen */.BC.mediumScreen(SliceCta_styles_templateObject3()), globalStyles/* media.smallScreen */.BC.smallScreen(SliceCta_styles_templateObject4()));
var ContentInner = globalStyles/* styled.div */.zo.div(SliceCta_styles_templateObject7(), globalStyles/* media.largeScreen */.BC.largeScreen(SliceCta_styles_templateObject6()));
var ContentTitle = globalStyles/* styled.div */.zo.div(SliceCta_styles_templateObject9(), function(props) {
    return props.theme.typography.thinFontFamily;
}, function(props) {
    return props.theme.typography.h1FontSize;
}, globalStyles/* media.smallScreen */.BC.smallScreen(SliceCta_styles_templateObject8()));
var ContentText = globalStyles/* styled.div */.zo.div(SliceCta_styles_templateObject12(), function(props) {
    return props.theme.typography.extraFontFamily;
}, function(props) {
    return props.theme.typography.baseFontSize;
}, globalStyles/* media.largeScreen */.BC.largeScreen(SliceCta_styles_templateObject10()), globalStyles/* media.smallScreen */.BC.smallScreen(SliceCta_styles_templateObject11()));

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceCta/SliceCta.tsx










var renderButton = function(primary) {
    if (primary.button_link && "url" in primary.button_link) {
        // check if url contains domain
        // const reg = new RegExp('^(?:[a-z]+:)?//', 'i');
        var reg = "/^(?:[a-z]+:)?///i";
        return reg.match(primary.button_link.url) ? // eslint-disable-next-line react/jsx-no-target-blank
        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            href: primary.button_link.url,
            target: "_blank",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                size: "lg",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                    field: primary === null || primary === void 0 ? void 0 : primary.button_label
                })
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: (0,prismic_config/* linkResolver */.kG)(primary.button_link),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: "home-page-hero__button",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                    size: "lg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                        field: primary === null || primary === void 0 ? void 0 : primary.button_label
                    })
                })
            })
        });
    }
    return null;
};
function SliceCta(param) {
    var primary = param.slice.primary;
    var ref;
    var videoId = primary === null || primary === void 0 ? void 0 : (ref = primary.video) === null || ref === void 0 ? void 0 : ref.video_id;
    var image = primary === null || primary === void 0 ? void 0 : primary.image;
    var label = "center";
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useMediaQuery/* useMediaQuery */.a)("(max-width: ".concat(constants/* smallScreen */.xC, "px)")), 1), isSmallScreen = ref1[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SliceCta_styles_Wrapper, {
        className: "slice-cta",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Video, {
                className: "media-wrapper",
                children: [
                    isSmallScreen && videoId && /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                        src: "https://player.vimeo.com/video/".concat(videoId, "?background=1&controls=0"),
                        frameBorder: "0",
                        allow: "autoplay; fullscreen",
                        allowFullScreen: true,
                        title: "video"
                    }),
                    isSmallScreen && !videoId && image && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicNextImage/* PrismicNextImage */.Z, {
                        field: image,
                        sizes: "100vw",
                        style: {
                            width: "100%",
                            height: "auto"
                        }
                    }),
                    !isSmallScreen && image && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicNextImage/* PrismicNextImage */.Z, {
                        field: image,
                        sizes: "100vw",
                        style: {
                            width: "100%",
                            height: "auto"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_Content, {
                className: "content-wrapper",
                justify: label,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentInner, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentTitle, {
                            children: primary.title && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                                field: primary.title
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentText, {
                            children: primary.text && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                                field: primary.text
                            })
                        }),
                        renderButton(primary)
                    ]
                })
            })
        ]
    });
}
SliceCta.componentName = "cta";

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceCta/index.ts


// EXTERNAL MODULE: ./src/@next/components/slices/SliceImageCta/index.tsx + 2 modules
var SliceImageCta = __webpack_require__(70872);
// EXTERNAL MODULE: ./src/@next/components/slices/SliceImageCards/index.ts + 2 modules
var SliceImageCards = __webpack_require__(71373);
// EXTERNAL MODULE: ./src/@next/components/slices/SliceInspiration/index.ts + 2 modules
var SliceInspiration = __webpack_require__(708);
// EXTERNAL MODULE: ./src/@next/components/slices/SliceInstagramPosts/index.ts + 5 modules
var SliceInstagramPosts = __webpack_require__(84057);
// EXTERNAL MODULE: ./src/@next/components/organisms/ProductReviews/ProductReviewsWithQuery.tsx
var ProductReviewsWithQuery = __webpack_require__(3177);
;// CONCATENATED MODULE: ./src/@next/components/slices/SliceReviews/styles.ts

function SliceReviews_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n"
    ]);
    SliceReviews_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var SliceReviews_styles_Wrapper = globalStyles/* styled.div */.zo.div(SliceReviews_styles_templateObject());

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceReviews/SliceReviews.tsx



function SliceReviews() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SliceReviews_styles_Wrapper, {
        className: "slice-reviews",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductReviewsWithQuery/* ProductReviewsWithQuery */.B, {})
    });
}
SliceReviews.componentName = "reviews";

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceReviews/index.ts


// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
;// CONCATENATED MODULE: ./src/@next/components/slices/SliceTrusted/styles.ts

function SliceTrusted_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-left: 0;\n    margin-right: 0;\n  "
    ]);
    SliceTrusted_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SliceTrusted_styles_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    border: none;\n  "
    ]);
    SliceTrusted_styles_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SliceTrusted_styles_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding 2em 0;\n  border-top: 1px solid #b9c5cb;\n  max-width: 100vw;\n  margin-left: 60px;\n  margin-right: 60px;\n  color: ",
        ";\n  line-height: 1.5em;\n  text-align: center;\n  font-family: ",
        ";\n  font-size: ",
        ";\n  ",
        "\n  ",
        "\n  * {\n    line-height: 1.5em;\n  }\n"
    ]);
    SliceTrusted_styles_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SliceTrusted_styles_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 100%;\n    flex-wrap: wrap;\n  "
    ]);
    SliceTrusted_styles_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SliceTrusted_styles_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  flex: 0 0 20%;\n  width: 77.7vw;\n  max-width: 1491px;\n  margin: 0 auto;\n  ",
        "\n"
    ]);
    SliceTrusted_styles_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SliceTrusted_styles_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    order: 2;\n    width: 16%;\n  "
    ]);
    SliceTrusted_styles_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function SliceTrusted_styles_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      max-width: 100%;\n    "
    ]);
    SliceTrusted_styles_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function SliceTrusted_styles_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      order: 0;\n      flex: 0 0 100%;\n      display: flex;\n      padding-top: 20px;\n      position: relative;\n      align-items: center;\n      justify-content: center;\n      margin-bottom: 15px;\n    "
    ]);
    SliceTrusted_styles_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function SliceTrusted_styles_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        margin: 0 7px;\n      "
    ]);
    SliceTrusted_styles_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function SliceTrusted_styles_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        position: absolute;\n        left: 50%;\n        top: 0;\n        transform: translateX(-50%);\n      "
    ]);
    SliceTrusted_styles_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function SliceTrusted_styles_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  img {\n    display: block;\n    margin: 0 auto;\n    width: auto;\n    height: auto;\n    max-width: 90px;\n    max-height: 40px;\n    ",
        "\n  }\n  &-rate {\n    ",
        "\n    p {\n      ",
        "\n    }\n    img {\n      margin-bottom: 13px;\n      ",
        "\n    }\n  }\n"
    ]);
    SliceTrusted_styles_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}

var SliceTrusted_styles_Wrapper = globalStyles/* styled.div */.zo.div(SliceTrusted_styles_templateObject2(), function(props) {
    return "rgba(".concat(props.theme.colors.baseFont, ", 0.8)");
}, function(props) {
    return props.theme.typography.extraFontFamily;
}, function(props) {
    return props.theme.typography.baseFontSize;
}, globalStyles/* media.mediumScreen */.BC.mediumScreen(SliceTrusted_styles_templateObject()), globalStyles/* media.smallScreen */.BC.smallScreen(SliceTrusted_styles_templateObject1()));
var styles_List = globalStyles/* styled.ul */.zo.ul(SliceTrusted_styles_templateObject4(), globalStyles/* media.mediumScreen */.BC.mediumScreen(SliceTrusted_styles_templateObject3()));
var styles_Item = globalStyles/* styled.li */.zo.li(SliceTrusted_styles_templateObject10(), globalStyles/* media.smallScreen */.BC.smallScreen(SliceTrusted_styles_templateObject5()), globalStyles/* media.smallScreen */.BC.smallScreen(SliceTrusted_styles_templateObject6()), globalStyles/* media.smallScreen */.BC.smallScreen(SliceTrusted_styles_templateObject7()), globalStyles/* media.smallScreen */.BC.smallScreen(SliceTrusted_styles_templateObject8()), globalStyles/* media.smallScreen */.BC.smallScreen(SliceTrusted_styles_templateObject9()));

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceTrusted/SliceTrusted.tsx





function SliceTrusted(param) {
    var fields = param.slice.fields;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SliceTrusted_styles_Wrapper, {
        className: "trusted",
        children: fields && /*#__PURE__*/ (0,jsx_runtime.jsx)(styles_List, {
            className: "trusted__list",
            children: fields.map(function(item, i) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles_Item, {
                    className: (0,clsx/* clsx */.W)("trusted__item", {
                        "trusted__item-rate": item.text
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicNextImage/* PrismicNextImage */.Z, {
                            field: item.image
                        }),
                        item.text && /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicRichText/* PrismicRichText */.v, {
                            field: item.text
                        })
                    ]
                }, i);
            })
        })
    });
}
SliceTrusted.componentName = "trusted";

;// CONCATENATED MODULE: ./src/@next/components/slices/SliceTrusted/index.ts


// EXTERNAL MODULE: ./src/@next/components/slices/SliceLinkButton/index.ts + 2 modules
var SliceLinkButton = __webpack_require__(80279);
;// CONCATENATED MODULE: ./src/@next/pages/HomePage/Slices.ts










var components = {
    // accordion: SliceAccordion,
    // architectreviews: SliceArchitectReviews,
    benefits: SliceBenefits,
    // benefitsprogram: SliceBenefitsProgram,
    collections: SliceCollections,
    // color_sample: SliceColorSample,
    // consulttoolbox: SliceConsultToolbox,
    // content_photo_photo_50: SliceBlogContentPhotoPhoto,
    // content_photo_text_30_60: SliceBlogContentTextPhoto,
    // content_text_photo_60_30: SliceBlogContentTextPhoto,
    // content_text_text_50: SliceBlogContentTextText,
    cta: SliceCta,
    imagecta: SliceImageCta/* SliceImageCta */.g,
    imagecard: SliceImageCards/* SliceImageCards */.a,
    // downloadfiles: SliceDownloadFiles,
    // excerpt: SliceExerpt,
    // formembded: SliceFormEmbded,
    // franchisecontact: SliceFranchiseContact,
    // heroimg: SliceHeroImg,
    // iconbanner: SliceIconBanner,
    // iconcta: SliceIconCta,
    inspiration: SliceInspiration/* SliceInspiration */.L,
    instagram_posts: SliceInstagramPosts/* SliceInstagramPosts */.J,
    // labeled_icons: SliceLabeledIcons,
    linkbutton: SliceLinkButton/* SliceLinkButton */.T,
    // mediaslider: SliceMediaSlider,
    // ourpartners: SliceOurPartners,
    // product_details: SliceProductDetails,
    // product_features: SliceProductFeatures,
    // quote: SliceQuote,
    // relatedpagesslider: SliceRelatedPagesSlider,
    reviews: SliceReviews,
    // richtext: SliceRichText,
    // showroom: SliceShowRoom,
    // tagimage: SliceTagImage,
    trusted: SliceTrusted
};

;// CONCATENATED MODULE: ./src/@next/pages/HomePage/styles.ts

function HomePage_styles_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 100vh;\n"
    ]);
    HomePage_styles_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var HomePage = globalStyles/* styled.div */.zo.div(HomePage_styles_templateObject());

;// CONCATENATED MODULE: ./src/@next/pages/HomePage/PrismicHomePage.tsx






function PrismicHomePage(param) {
    var homepage = param.homepage;
    if (!homepage) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePage, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "prismic-home-page",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorMessage/* ErrorMessage */.B, {
                        errors: [
                            {
                                message: "oops"
                            }
                        ]
                    }),
                    ";"
                ]
            })
        });
    }
    var ref = homepage || {}, hero = ref.hero, body = ref.body;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(HomePage, {
        children: [
            hero && /*#__PURE__*/ (0,jsx_runtime.jsx)(HomePageHero, {
                hero: hero
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SliceZone/* SliceZone */.p, {
                    slices: body,
                    components: components
                })
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/@next/pages/HomePage/index.tsx


;// CONCATENATED MODULE: ./src/views/Home/Page.tsx



var Page = function(param) {
    var shop = param.shop, homepage = param.homepage;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicHomePage, {
        homepage: homepage
    });
};
/* harmony default export */ var Home_Page = (Page);

;// CONCATENATED MODULE: ./src/views/Home/View.tsx







var View = function(param) {
    var shop = param.shop, homepage = param.homepage, seo = param.seo;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "home-page",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, (0,_object_spread/* default */.Z)({}, seo)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: structuredData(shop)
                    }
                }, "homepage-jsonld")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Home_Page, {
                shop: shop,
                homepage: homepage
            })
        ]
    });
};
/* harmony default export */ var Home_View = (View);

;// CONCATENATED MODULE: ./src/views/Home/index.tsx


;// CONCATENATED MODULE: ./src/pages/index.ts
// import { GetStaticPaths, GetStaticProps } from 'next';

var __N_SSG = true;
/* harmony default export */ var pages = (Home_View);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2962,3537,4547,9434,9774,2888,179], function() { return __webpack_exec__(89886); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);